export default __webpack_public_path__ + "static/media/way.1898d972.svg";